export const TRANSIENT_RETRY_DELAYS_MS = [1_000, 2_000, 5_000, 10_000, 30_000] as const;

export function transientRetryDelayMs(attempt: number): number {
  const normalizedAttempt = Number.isFinite(attempt)
    ? Math.max(0, Math.floor(attempt))
    : 0;
  return TRANSIENT_RETRY_DELAYS_MS[
    Math.min(normalizedAttempt, TRANSIENT_RETRY_DELAYS_MS.length - 1)
  ];
}

export function canRunTransientRetry(visibilityState: string, online: boolean): boolean {
  return visibilityState === "visible" && online;
}
